import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Tabs from "../../../components/tabs";
import TabPanel from "../../../components/tabs/tabpanel";
import Upcoming from "./upcoming";
import Cancelled from "./cancelled";
import Completed from "./completed";
import TimeDisplay from "../../../components/TimeDisplay";

import { list, filterList } from "./data";
import Search from "../../../components/search";

//
import {
  setAllAppointments,
  setAllUpcomingCount,
  setAllCompletedCount,
  setAllCancelledCount,
  setAllNoShowCount,
  setMediumUpcomingAppointmentsPage,
  setMediumUpcomingAppointmentsrowsPerPage,
  setMediumCompletedAppointmentsPage,
  setMediumCompletedAppointmentsrowsPerPage,
  setMediumCancelledAppointmentsPage,
  setMediumCancelledAppointmentsrowsPerPage,
  setMediumNoShowAppointmentsPage,
  setMediumNoShowAppointmentsrowsPerPage,
} from "../../../reducer/mediumSlice";

//service
import {
  getAllAppointments,
  changeAppointmentStatus,
  filterAllAppointments,
  setNewTimeZone,
  changeAppointmentStatusPractice,
  refundingAppointment,
  stopPaymentAppointment,
  blockUserfromMedium,
} from "../../../services/medium";

import "./appointments.css";
import NoShows from "./noshows";
import { getTimezones } from "../../../services/uidata";
import { setTimezoneArray } from "../../../reducer/uidataSlice";
import { setNewTimeZoneData, setUser } from "../../../reducer/userSlice";
import {
  emptyAllSelectBox,
  filterVisibleTimeZones,
} from "../../../utils/helpers";
import {
  setLoading,
  setLoadingContent,
  setLoadingText,
} from "../../../reducer/auth/auth";
import Select from 'react-select';
import { toast } from "react-toastify";
import { showRefundNotice } from "../../../utils/refundNotice";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { use } from "react";
import { fetchUser } from "../../../services/auth";

export default function Appointments() {
  const { timezoneArray } = useSelector((state) => state.uidata);
  const { timezone, id } = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const {
    allUpcomingAppointments,
    allCompletedAppointments,
    allCancelledAppointments,
    allNoShowsAppointments,
    allUpcomingCount,
    allCompletedCount,
    allCancelledCount,
    allNoShowCount,
    mediumupcomingAppointmentsPage,
    mediumupcomingAppointmentsrowsPerPage,

    mediumcompletedAppointmentsPage,
    mediumcompletedAppointmentsrowsPerPage,

    mediumcancelledAppointmentsPage,
    mediumcancelledAppointmentsrowsPerPage,

    mediumnoshowAppointmentsPage,
    mediumnoshowAppointmentsrowsPerPage,
    globalRowsPerPage,
  } = useSelector((state) => state.medium);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(0);
  const [upcomingAppointment, setUpcomingAppointments] = useState([]);
  const [completedAppointment, setCompletedAppointments] = useState([]);
  const [canceledAppointment, setCanceledAppointments] = useState([]);
  const [showAppointment, setShowAppointments] = useState([]);
  const [listArray, setListArray] = useState(list);
  const [backuupcoming, setbackupUpcoming] = useState([]);
  const [backuupcompleted, setbackupCompleted] = useState([]);
  const [backuupcancelled, setbackupCancelled] = useState([]);
  const [backuupnoshow, setbackupUpNoShow] = useState([]);
  const [timezoneData, setTimezoneData] = useState([]);

  const [filterValues, setFilterValues] = useState("screen_name");
  const [searchValue, setSearchValues] = useState();
  const [noShowValue, setNowShowValues] = useState(0);

  const [appointment_id, setappointment_id] = useState("");

  const [blink, setBlink] = useState(false);
  const [message, setMessage] = useState("");
  const [paymentMessagarType, setPaymentMessagarType] = useState("");

  useEffect(() => {
    const from = searchParams.get("from");
    const message1 = searchParams.get("message");
    const appointment_i = searchParams.get("appointment_id");
    console.log(from, "Client Confirm");
    // appointments?from=goondemand&appointment_id${data.appointment.id}&message=${data.message}`)
    if (searchParams.get("payment_status") !== null) {
      if (searchParams.get("payment_status") === "success") {
        setPaymentMessagarType("success");
      } else {
        setPaymentMessagarType("failed");
      }
    }
    if (from === "goondemand") {
      setappointment_id(appointment_i);
      setMessage(message1);
      // toast.success(message, { position: "top-center" })
      setBlink(true);
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("from");
      newUrl.searchParams.delete("message");
      newUrl.searchParams.delete("appointment_id");
      window.history.replaceState({}, document.title, newUrl.href);
    } else {
      setBlink(false);
    }
  }, []);
  useEffect(() => {
    localStorage.removeItem("appoinmentId");

    const immediate_session_appointment_id = localStorage.getItem(
      "immediate_session_appointment_id"
    );
    if (immediate_session_appointment_id) {
      setappointment_id(immediate_session_appointment_id);
      setBlink(true);
      localStorage.removeItem("immediate_session_appointment_id");
    }

    // let from = searchParams.get('from')
    // console.log(from, "from")
    // if (from === "goondemand") {

    const data = {
      page: 1,
      rowsPerPage: 10,
    };

    getAllAppointmentsList(data, activeTab);

    // }
    // if (from === "onboarding") {
    // }

    if (!timezoneArray.length) updateTimezones();
    launcApi();
  }, []);
  useEffect(() => {
    setTimezoneData(filterVisibleTimeZones(timezoneArray));
  }, [timezoneArray]);

  const changeTimeZoneHandler = (e) => {
    dispatch(setLoading(true));
    let id = e.target.value;
    let body = {
      timezone_id: id,
    };
    setNewTimeZone(body)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          // Fetch updated user data and update Redux state
          fetchUser()
            .then((userData) => {
              dispatch(setUser(userData.data.data));
              localStorage.setItem(
                "userTimezone",
                JSON.stringify(userData.data.data)
              );
            })
            .catch((err) => console.log(err));

          const data = {
            page: 1,
            rowsPerPage: 10,
          };
          getAllAppointmentsList(data, activeTab);
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const filterTimeZone = (id) => {
    let zone;
    timezoneData.filter((item) => {
      if (parseInt(id) === parseInt(item.id)) {
        zone = item.front_name;
      }
    });
    console.log(zone);
    return zone;
  };
  // useEffect(() => {
  //   const data={
  //     page:1,
  //     rowsPerPage:10
  //   }
  //   console.log('activeTab',activeTab);
  //   getAllAppointmentsList(data,activeTab);

  // }, [activeTab]);
  useEffect(() => {
    console.log(
      allCompletedAppointments,
      allUpcomingAppointments,
      allCancelledAppointments,
      allNoShowsAppointments
    );
    setListedArray(allUpcomingAppointments, setUpcomingAppointments);
    setListedArray(allCompletedAppointments, setCompletedAppointments);
    setListedArray(allCancelledAppointments, setCanceledAppointments);
    setListedArray(allNoShowsAppointments, setShowAppointments);
    setListArray(
      list.map((item) => {
        if (item.name === "Upcoming") {
          return {
            ...item,
            ...(item.count = allUpcomingCount),
            className: "",
          };
        }
        if (item.name === "Completed") {
          return {
            ...item,
            ...(item.count = allCompletedCount),
            className: "",
          };
        }

        if (item.name === "Cancelled") {
          return {
            ...item,
            ...(item.count = allCancelledCount),
            className: "",
          };
        }

        if (item.name === "No Shows") {
          return {
            ...item,
            ...(item.count = allNoShowCount),
            className: "",
          };
        }
      })
    );
  }, [
    allCompletedAppointments,
    allUpcomingAppointments,
    allCancelledAppointments,
    allNoShowsAppointments,
    blink,
  ]);
  const getPaginationData = (data, activeTab) => {
    getAllAppointmentsList(data, activeTab);
  };

  const updateTimezones = () => {
    getTimezones()
      .then((data) => {
        dispatch(setTimezoneArray(data.data.data));
      })
      .catch((err) => console.log(err));
  };
  const checkStatus0Values = (data) => {
    var countStatus = activeTab == 0;

    if (data && Array.isArray(data.attendees)) {
      return data.attendees.filter(function (info) {
        return info.status == countStatus;
      });
    }

    return [];
  };

  const checkWorkersValues = (data) => {
    var countStatus = activeTab == 0;

    if (data && Array.isArray(data.workers)) {
      return data.workers.filter(function (info) {
        return info.status == countStatus;
      });
    }

    return [];
  };
  const setListedArray = (item, set) => {
    const values = item.map((resp) => {
      return {
        ...resp,
        status: false,
        statusValue: "",
        nostatusValue: "",
        noOfAttendees: checkStatus0Values(resp),
        noOfWorkers: checkWorkersValues(resp),
        noShowTimes: getTimeDiff(resp),
      };
    });

    set(values);
  };
  const onClickHandler = (e, id, name) => {
    e.stopPropagation();
    if (name === "upcoming") {
      const response = upcomingAppointment.map((user) => {
        if (user.appointmentId === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setUpcomingAppointments(response);
    }
    if (name === "completed") {
      const response = completedAppointment.map((user) => {
        if (user.appointmentId === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setCompletedAppointments(response);
    }
    // const responsee = upcomingAppointment.map((user) => {
    //   return {
    //     ...user,
    //     status: false,
    //   };
    // });
    // setTimeout(() => {
    //   setUpcomingAppointments(responsee);
    // }, 8000);
    // if (name == "novice") {
    //   const response = novice.map((user) => {
    //     if (user.id === id) {
    //       user.status = !user.status;
    //     } else {
    //       user.status = false;
    //     }
    //     return user;
    //   });
    //   setNovice(response);
    // }
    // if (name == "professional") {
    //   const response = professionals.map((user) => {
    //     if (user.id === id) {
    //       user.status = !user.status;
    //     } else {
    //       user.status = false;
    //     }
    //     return user;
    //   });
    //   setProfessionals(response);
    // }
    // if (name == "pendingAprrovals") {
    //   const response = pendingApprovals.map((user) => {
    //     if (user.id === id) {
    //       user.status = !user.status;
    //     } else {
    //       user.status = false;
    //     }
    //     return user;
    //   });
    //   setPendingApprovals(response);
    // }
  };
  const getAllAppointmentsList = (paginationdata, activeTab, info) => {
    if (info === "refresh") {
      // setUpcomingAppointments([])
      // setCanceledAppointments([])
      // setCompletedAppointments([])
      // setShowAppointments([])
    }
    let appointmentType = "";
    if (activeTab === 0) {
      appointmentType = "upcoming";
    }
    if (activeTab === 1) {
      appointmentType = "completed";
    }
    if (activeTab === 2) {
      appointmentType = "cancelled";
    }
    if (activeTab === 3) {
      appointmentType = "show";
    }
    if (activeTab === 4) {
      appointmentType = "ongoing";
    }
    dispatch(setLoading(true));
    console.log(
      searchValue,
      filterValues,
      "session_type=${session_type}&name=${screen_name}&meeting_id=${meeting_id}`"
    );

    let newbody = {
      session_type:
        searchValue !== undefined && searchValue.session_type !== undefined
          ? searchValue.session_type
          : "",
      screen_name:
        searchValue !== undefined && searchValue.screen_name !== undefined
          ? searchValue.screen_name
          : "",
      meeting_id:
        searchValue !== undefined && searchValue.meeting_id !== undefined
          ? searchValue.meeting_id
          : "",
    };
    Object.assign(paginationdata, newbody);
    console.log(paginationdata, paginationdata, "paginationdata");
    getAllAppointments(paginationdata, appointmentType)
      .then((data) => {
        if (data.data.status) {
          console.log(
            data.data.data.upcoming.length,
            "data.data.datadata.data.data"
          );
          // dispatch(setAllUpcomingCount(JSON.parse(JSON.stringify(data.data.data.upcoming_pagination.total))))
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.upcoming_pagination.total)
              )
            )
          );

          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.completed_pagination.total)
              )
            )
          );
          dispatch(
            setAllCancelledCount(
              JSON.parse(
                JSON.stringify(data.data.data.cancelled_pagination.total)
              )
            )
          );
          dispatch(
            setAllNoShowCount(
              JSON.parse(JSON.stringify(data.data.data.show_pagination.total))
            )
          );
          dispatch(setAllAppointments(data.data.data));
          setbackupUpcoming(
            JSON.parse(JSON.stringify(data.data.data.upcoming))
          );
          setbackupCompleted(
            JSON.parse(JSON.stringify(data.data.data.completed))
          );
          setbackupCancelled(
            JSON.parse(JSON.stringify(data.data.data.cancelled))
          );
          setbackupUpNoShow(JSON.parse(JSON.stringify(data.data.data.show)));

          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };
  const launcApi = () => {
    const data = {
      page: 1,
      rowsPerPage: 10,
    };
    if (
      !allUpcomingAppointments.length > 0 ||
      !allCompletedAppointments.length > 0 ||
      !allCancelledAppointments.length > 0 ||
      !allNoShowsAppointments.length > 0
    ) {
      getAllAppointmentsList(data, activeTab);
    }
  };
  const changeStatusPractice = (userId, status, appointmentId, type, ids) => {
    dispatch(setLoadingText(true));
    dispatch(
      setLoadingContent(
        "<div>Please wait, We are updating your appointment</div>"
      )
    );
    let body;

    body = {
      appointment_id: appointmentId,
      user_id: userId,
    };

    changeAppointmentStatusPractice(body)
      .then((data) => {
        emptyAllSelectBox();
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(""));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

          setTimeout(() => {
            if (type === "medium") {
              //no show
              toast.success("Appointment status updated succesfully", {
                position: "top-center",
              });
            } else {
              toast.success("Appointment cancelled succesfully", {
                position: "top-center",
              });
            }
          }, 1000);

          const info = {
            page: 1,
            rowsPerPage: 10,
          };
          getAllAppointmentsList(info, activeTab, "refresh");
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
      });
  };

  const blockUser = (appointment_id, user_id, client_id) => {
    let check = parseInt(id) === parseInt(user_id) ? client_id : user_id;
    let body = {
      appointment_id: appointment_id,
      blocked_by: id,
      blocked_user: check,
    };
    blockUserfromMedium(body)
      .then((data) => {
        if (data.data.status) {
          toast.success(data.data.message, {
            position: "top-center",
          });
          let dat = {
            page: 1,
            rowsPerPage: 10,
          };
          getAllAppointmentsList(dat, activeTab);
        } else {
          toast.error(data.data.message, {
            position: "top-center",
          });
        }
      })
      .catch(() => {});
  };
  const changeStatus = (
    userId,
    status,
    appointmentId,
    type,
    ids,
    sessionType = 0,
    noShowBy = 0,
    selectedReason
  ) => {
    console.log(noShowBy, " noShowBy");
    dispatch(setLoadingText(true));
    dispatch(
      setLoadingContent(
        "<div>Please wait, We are updating your appointment</div>"
      )
    );
    let body;
    if (selectedReason && selectedReason != "") {
      body = {
        userId: userId,
        status: status,
        appointmentId: appointmentId,
        restrictByMedium: true,
        reason: selectedReason,
      };
    } else {
      body = {
        userId: userId,
        status: status,
        appointmentId: appointmentId,
        restrictByMedium: true,
      };
    }

    changeAppointmentStatus(body)
      .then((data) => {
        emptyAllSelectBox();
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(""));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

          setTimeout(() => {
            if (type === "medium") {
              //no show
              toast.success("Appointment status updated succesfully", {
                position: "top-center",
              });
            } else {
              toast.success("Appointment cancelled succesfully", {
                position: "top-center",
              });
            }
            if (
              status == 2 &&
              data.data.data.backfill_status &&
              data.data.data.backfill_status == 1 &&
              noShowBy == "other"
            ) {
              if (sessionType == 5 || sessionType == 7 || sessionType == 8)
                window.loadModal2("#BackFillConfirmation", "show");
            }
          }, 1000);

          const info = {
            page: 1,
            rowsPerPage: 10,
          };
          getAllAppointmentsList(info, activeTab, "refresh");
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
      });
  };
  const changeHandler = (
    e,
    status,
    appointmentId,
    id,
    type,
    ids,
    sessionType,
    noShowBy,
    selectedReason = ""
  ) => {
    changeStatus(
      id,
      status,
      appointmentId,
      type,
      ids,
      sessionType,
      noShowBy,
      selectedReason
    );
  };
  const changeHandle1 = (
    e,
    status,
    appointmentId,
    id,
    type,
    ids,
    sessionType,
    noShowBy
  ) => {
    changeStatusPractice(
      id,
      status,
      appointmentId,
      type,
      ids,
      sessionType,
      noShowBy
    );
  };
  const filterListAppointments = (constants) => {
    console.log(activeTab);
    const { session_type, screen_name, meeting_id } = constants;
    let body = {
      session_type,
      screen_name,
      meeting_id,
    };
    // if (activeTab == 0) {
    filterAllAppointments(body)
      .then((data) => {
        if (data.data.status) {
          if (parseInt(activeTab) === 0) {
            dispatch(
              setMediumUpcomingAppointmentsPage(
                mediumupcomingAppointmentsPage + 1
              )
            );
            dispatch(
              setMediumUpcomingAppointmentsrowsPerPage(globalRowsPerPage)
            );
          } else if (parseInt(activeTab) === 1) {
            dispatch(
              setMediumCompletedAppointmentsPage(
                mediumcompletedAppointmentsPage + 1
              )
            );
            dispatch(
              setMediumCompletedAppointmentsrowsPerPage(globalRowsPerPage)
            );
          } else if (parseInt(activeTab) === 2) {
            dispatch(
              setMediumCancelledAppointmentsPage(
                mediumcancelledAppointmentsPage + 1
              )
            );
            dispatch(
              setMediumCancelledAppointmentsrowsPerPage(globalRowsPerPage)
            );
          } else if (parseInt(activeTab) === 3) {
            dispatch(
              setMediumNoShowAppointmentsPage(mediumnoshowAppointmentsPage + 1)
            );
            dispatch(setMediumNoShowAppointmentsrowsPerPage(globalRowsPerPage));
          }

          console.log(
            data.data.data.upcoming_pagination.total,
            "data.data.data"
          );
          dispatch(
            setAllUpcomingCount(
              JSON.parse(
                JSON.stringify(data.data.data.total_upcoming_appointments)
              )
            )
          );

          dispatch(
            setAllCompletedCount(
              JSON.parse(
                JSON.stringify(data.data.data.completed_pagination.total)
              )
            )
          );
          dispatch(
            setAllCancelledCount(
              JSON.parse(
                JSON.stringify(data.data.data.cancelled_pagination.total)
              )
            )
          );
          dispatch(
            setAllNoShowCount(
              JSON.parse(JSON.stringify(data.data.data.show_pagination.total))
            )
          );
          dispatch(setAllAppointments(data.data.data));
        }
      })
      .catch(() => {});
    // }

    // if (activeTab == 1) {
    //   filterAllAppointments(body)
    //     .then((data) => {
    //       if (data.data.status) {
    //         dispatch(setAllAppointments(data.data.data));
    //       }
    //     })
    //     .catch(() => {});
    // }
    // if (activeTab == 2) {
    //   filterAllAppointments(body)
    //     .then((data) => {
    //       if (data.data.status) {
    //         dispatch(setAllAppointments(data.data.data));
    //       }
    //     })
    //     .catch(() => {});
    // }
    // if (activeTab == 3) {
    //   filterAllAppointments(body)
    //     .then((data) => {
    //       if (data.data.status) {
    //         dispatch(setAllAppointments(data.data.data));
    //       }
    //     })
    //     .catch(() => {});
    // }
  };
  const filterReset = () => {
    setFilterValues("screen_name");
    setSearchValues("");
    let dataVal = {
      email: "",
      client_name: "",
      created_at: "",
      orderBy: "asc",
      referal_code: "",
      created_at_order_by: "",
    };
    filterListAppointments(dataVal);
  };
  const clearBackfillModalState = () => {
    if (window.jQuery) {
      window.jQuery("#BackFillConfirmation").modal("hide");
      window.jQuery(".modal-backdrop").remove();
    }

    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => {
      backdrop.remove();
    });
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
  };

  const goToMediumBackFill = (appointmentId) => {
    clearBackfillModalState(); // closes Popup 1 (#BackFillConfirmation)

    navigate(
      `/go-on-demand-client?source=backfill&sourceAppointmentId=${encodeURIComponent(
        appointmentId
      )}`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setNowShowValues((prevValue) => prevValue + 1);
    }, 60000); // 60000 ms = 1 minute

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  useEffect(() => {
    let appoinment = upcomingAppointment.map((info) => {
      return {
        ...info,
        noShowTimes: getTimeDiff(info),
      };
    });
    setUpcomingAppointments(appoinment);
  }, [noShowValue]);
  const getTimeDiff = (appoinment) => {
    let appdate = moment(appoinment.date).format("YYYY/MM/DD");
    let now = moment().format();
    let datetimeB = moment(appdate + " " + appoinment.time);

    let final = datetimeB.diff(now, "minutes");
    // console.log(final)
    let status;
    final > -5 ? (status = true) : (status = false);
    return status;
  };
  // Group sessions nest one row per attendee under appointment.attendees[],
  // each with its own transaction/payment_status; a refund/waive can target
  // either a top-level (1:1) row or one specific attendee's row, so this
  // patches whichever one matches appointmentId instead of assuming it's
  // always the top-level row.
  //
  // The host (whoever originally booked, parent_id null) appears TWICE in
  // the payload: once as the top-level appointment row itself, and again as
  // the last entry inside its own attendees[] (see Controller::
  // makeAppointmentResponseArray — `$response[...]['attendees'][] = $value`
  // pushes the row into its own attendees list). Refunding the host matches
  // appointment.id, but the NoshowBox modal only ever reads attendees[], so
  // both copies must be patched — returning early after the top-level match
  // (as this used to do) left the attendees[] copy stale, which is exactly
  // why the popup kept showing "Paid" for the host attendee until reload.
  const patchPaymentStatus = (list, appointmentId, newStatus, extra = {}) =>
    list.map((appointment) => {
      let updated = appointment;

      if (appointment.id === appointmentId) {
        updated = { ...updated, payment_status: newStatus, ...extra };
      }

      if (Array.isArray(appointment.attendees)) {
        const attendeeIndex = appointment.attendees.findIndex(
          (attendee) => attendee.id === appointmentId
        );
        if (attendeeIndex !== -1) {
          const updatedAttendees = [...appointment.attendees];
          updatedAttendees[attendeeIndex] = {
            ...updatedAttendees[attendeeIndex],
            payment_status: newStatus,
            ...extra,
          };
          updated = { ...updated, attendees: updatedAttendees };
        }
      }

      return updated;
    });

  const refundingCall = (mediumId, appointmentId, isSurweyPending = false, onSuccess) => {
    let body;
    if (isSurweyPending) {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
        is_survey_pending: 1,
      };
    } else {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
      };
    }

    refundingAppointment(body)
      .then((data) => {
        emptyAllSelectBox();
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(""));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

          setTimeout(() => {
            showRefundNotice(data);
          }, 1000);
          if (activeTab == 0) {
            setUpcomingAppointments(
              patchPaymentStatus(upcomingAppointment, appointmentId, "Refunding")
            );
          } else if (activeTab == 1) {
            setCompletedAppointments(
              patchPaymentStatus(
                completedAppointment,
                appointmentId,
                "Refunding",
                isSurweyPending ? { survey_status_type: 1, survey_link: null } : {}
              )
            );
          } else if (activeTab == 2) {
            setCanceledAppointments(
              patchPaymentStatus(canceledAppointment, appointmentId, "Refunding")
            );
          }

          // const info = {
          //   page: 1,
          //   rowsPerPage: 10
          // }
          // getAllAppointmentsList(info, activeTab, 'refresh');

          // The local patch above only updates the master appointment lists.
          // A NoshowBox opened for a group session renders a separate
          // `attendeesList` snapshot taken when it was opened, which the
          // patch doesn't touch — callers refunding a specific attendee pass
          // onSuccess to force the same full refetch the No Show/Remove
          // attendee actions already rely on, so the next time the attendee
          // list is opened it reflects the refund without a page reload.
          if (typeof onSuccess === "function") {
            onSuccess();
          }
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
      });
  };
  const refundingCallUpcomming = (
    mediumId,
    appointmentId,
    isSurweyPending = false
  ) => {
    let body;
    if (isSurweyPending) {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
        is_survey_pending: 1,
      };
    } else {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
      };
    }
    refundingAppointment(body)
      .then((data) => {
        emptyAllSelectBox();
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(""));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

          setTimeout(() => {
            showRefundNotice(data);
          }, 1000);

          // const info = {
          //   page: 1,
          //   rowsPerPage: 10
          // }
          // getAllAppointmentsList(info, activeTab, 'refresh');
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
      });
  };
  const stopPaymentCall = (
    mediumId,
    appointmentId,
    isSurweyPending = false,
    onSuccess
  ) => {
    let body;
    if (isSurweyPending) {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
        is_survey_pending: 1,
      };
    } else {
      body = {
        medium_id: mediumId,
        appointment_id: appointmentId,
      };
    }

    stopPaymentAppointment(body)
      .then((data) => {
        emptyAllSelectBox();
        setTimeout(() => {
          dispatch(setLoadingText(false));
          dispatch(setLoadingContent(""));
        }, 1000);
        if (data.data.status) {
          // dispatch(setLoading(false))

          setTimeout(() => {
            //no show
            toast.success("Status Updated Successfully", {
              position: "top-center",
            });
          }, 1000);
          if (activeTab == 0) {
            setUpcomingAppointments(
              patchPaymentStatus(upcomingAppointment, appointmentId, "Waived")
            );
          } else if (activeTab == 1) {
            setCompletedAppointments(
              patchPaymentStatus(
                completedAppointment,
                appointmentId,
                "Waived",
                isSurweyPending ? { survey_status_type: 1, survey_link: null } : {}
              )
            );
          } else if (activeTab == 2) {
            setCanceledAppointments(
              patchPaymentStatus(canceledAppointment, appointmentId, "Waived")
            );
          }

          // const info = {
          //   page: 1,
          //   rowsPerPage: 10
          // }
          // getAllAppointmentsList(info, activeTab, 'refresh');

          // See the matching comment in refundingCall — needed so a waived
          // attendee's status is visible next time the attendee list modal
          // is reopened, not just after a page reload.
          if (typeof onSuccess === "function") {
            onSuccess();
          }
        } else {
          // ✅ THIS will show "Transaction not found"
          toast.error(data.data.message || "Something went wrong", {
            position: "top-center",
          });
        }
      })
      .catch(() => {
        dispatch(setLoadingText(false));
        dispatch(setLoadingContent(""));
        //    toast.error("Something went wrong", {
        //   position: "top-center",
        // });
      });
  };
  return (
    <div className="all-medium-page">
      {blink && message !== "" && message !== null && (
        <div
          class="alert alert-success d-flex align-items-center justify-content-center font-size-20 height-56"
          role="alert"
        >
          <b> {message}</b>
        </div>
      )}
      {paymentMessagarType === "success" && (
        <div class="alert alert-success" role="alert">
          Your payment is processed successfully.
        </div>
      )}
      {paymentMessagarType === "failed" && (
        <div class="alert alert-danger" role="alert">
          Your payment is not processed, Please try again.
        </div>)}
      {console.log(message,"message")}
      {/* Row 1: Learn more (left) + Current Time (right) */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px', marginBottom: '12px' }}>
        <a target="_blank" className="font-size-14 text-underline pointer learn-more-btn" href="https://vimeo.com/922676519/c68142040f?share=copy">Learn more</a>
        <TimeDisplay timeMargine={2} format="HH:mm:ss A" />
      </div>
      {/* Timezone (left) + Filter (right) — same styled box */}
      <div className="bottomClass" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
        <div style={{ flex: '1 1 auto', minWidth: 160 }}>
          <Select
            options={timezoneData.map(function(item) { return { value: item.id, label: item.front_name }; })}
            value={(function() { var found = timezoneData.find(function(item) { return item.front_name === timezone; }); return found ? { value: found.id, label: found.front_name } : null; })()}
            onChange={function(opt) { changeTimeZoneHandler({ target: { value: (opt || {}).value || '' } }); }}
            placeholder="Change Timezone"
            styles={{
              control: function(base) { return Object.assign({}, base, { borderRadius: 13, borderColor: '#ccc', minHeight: window.innerWidth <= 767 ? 52 : 40, fontSize: 14, cursor: 'pointer' }); },
              valueContainer: function(base) { return Object.assign({}, base, { flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word', padding: window.innerWidth <= 767 ? '10px 12px' : '2px 8px' }); },
              singleValue: function(base) { return Object.assign({}, base, { whiteSpace: 'normal', wordBreak: 'break-word', overflow: 'visible' }); },
              menu: function(base) { return Object.assign({}, base, { zIndex: 9999 }); },
            }}
          />
        </div>
        <div className="d-flex gap-10 flex-wrap">
          <Search
            callApi={filterListAppointments}
            list={filterList}
            setSearchValues={setSearchValues}
            setFilterValues={setFilterValues}
            searchValue={searchValue}
            filterValues={filterValues}
          />
        </div>
      </div>
      <Tabs active={activeTab} list={listArray} setActiveTab={setActiveTab} />
      <ul className="tabs-content">
        <TabPanel id={0} activeTab={activeTab}>
          <Upcoming
            upcomingAppointments={upcomingAppointment}
            changeHandler={changeHandler}
            onClickHandler={onClickHandler}
            filterListAppointments={filterListAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            changeHandle1={changeHandle1}
            setSearchValues={setSearchValues}
            getAllAppointmentsList={getAllAppointmentsList}
            activeTab={activeTab}
            searchValue={searchValue}
            filterValues={filterValues}
            setAppointments={setUpcomingAppointments}
            goToMediumBackFill={goToMediumBackFill}
            blink={blink}
            appointment_id={appointment_id}
            refundingCallUpcomming={refundingCallUpcomming}
            refundingCall={refundingCall}
            stopPaymentCall={stopPaymentCall}
          />
        </TabPanel>
        <TabPanel id={1} activeTab={activeTab}>
          <Completed
            completedAppointments={completedAppointment}
            changeHandler={changeHandler}
            onClickHandler={onClickHandler}
            filterListAppointments={filterListAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            changeHandle1={changeHandle1}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            getAllAppointmentsList={getAllAppointmentsList}
            activeTab={activeTab}
            searchValue={searchValue}
            filterValues={filterValues}
            refundingCall={refundingCall}
            stopPaymentCall={stopPaymentCall}
            blockUser={blockUser}
            goToMediumBackFill={goToMediumBackFill}
            setBlink={setBlink}
          />
        </TabPanel>
        <TabPanel id={2} activeTab={activeTab}>
          <Cancelled
            canceledAppointment={canceledAppointment}
            changeHandler={changeHandler}
            filterListAppointments={filterListAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            activeTab={activeTab}
            blockUser={blockUser}
            getAllAppointmentsList={getAllAppointmentsList}
            setBlink={setBlink}
            refundingCall={refundingCall}
            stopPaymentCall={stopPaymentCall}
          />
        </TabPanel>
        <TabPanel id={3} activeTab={activeTab}>
          <NoShows
            showAppointment={showAppointment}
            activeTab={activeTab}
            changeHandler={changeHandler}
            filterListAppointments={filterListAppointments}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            blockUser={blockUser}
            getAllAppointmentsList={getAllAppointmentsList}
            setBlink={setBlink}
          />
        </TabPanel>
      </ul>

    </div>
  );
}
